import ServiceForm from './ServiceForm';

export default function HeroSection() {
  return (
    <section
      id="top"
      className="relative text-white pt-28 pb-20 min-h-[600px] md:min-h-[700px] flex items-center"
    >
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        role="img"
        aria-label="Professional home service truck parked in front of a suburban house"
        style={{
          backgroundImage: 'url("https://public.readdy.ai/ai/img_res/e9eb4364892c9b6d8129aba41541d975.jpg")',
        }}
      />
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#0A2540]/90 via-[#0A2540]/75 to-[#0A2540]/40" />

      <div className="relative w-full max-w-screen-xl mx-auto px-6">
        <div className="max-w-2xl">
          {/* Available badge */}
          <div className="inline-flex items-center gap-2 bg-white/10 border border-[#10B981]/40 px-3 py-1.5 rounded-full mb-6">
            <span className="relative flex items-center justify-center h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#10B981] opacity-75" />
              <span className="relative inline-flex rounded-full h-2 w-2 bg-[#10B981]" />
            </span>
            <span className="text-xs font-bold text-[#10B981] uppercase tracking-widest">Dispatching Now — 24/7</span>
          </div>

          {/* H1 */}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-tight font-heading text-white mb-4">
            Top-Rated Local Home Service Pros,{' '}
            <span className="text-[#FF6B00]">Dispatched Immediately.</span>
          </h1>

          <p className="text-base sm:text-lg text-white/80 leading-relaxed mb-2 font-body">
            Skip the endless searching. Select your service, enter your zip code, and get matched with{' '}
            <strong className="text-white">pre-vetted, licensed experts</strong> in your exact neighborhood.
          </p>

          {/* Trust badges inline */}
          <div className="flex flex-wrap gap-3 mb-2">
            {['Licensed & Insured', 'Background Checked', 'Upfront Pricing'].map((badge) => (
              <span
                key={badge}
                className="inline-flex items-center gap-1.5 text-xs font-semibold text-[#10B981] bg-[#10B981]/10 border border-[#10B981]/30 px-3 py-1 rounded-full"
              >
                <div className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-checkbox-circle-fill text-[#10B981] text-xs" />
                </div>
                {badge}
              </span>
            ))}
          </div>

          {/* Multi-step form */}
          <ServiceForm
            formAction="https://readdy.ai/api/form/d7416kj41deorl02ek7g"
            formId="hero-service-form"
            dark
          />
        </div>
      </div>
    </section>
  );
}
